import {
  GET_CC_ORDER_PROCESSING_REQUEST,
  GET_CC_ORDER_PROCESSING_SUCCESS,
  GET_CC_ORDER_PROCESSING_ERROR,
  CREATE_CC_ORDER_PROCESSING_REQUEST,
  CREATE_CC_ORDER_PROCESSING_SUCCESS,
  CREATE_CC_ORDER_PROCESSING_ERROR,
} from "./types.js";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const getCCOrderProcessing = (token, values) => (dispatch) => {

  let cleanedVal = values.customer === undefined ? null : values.customer.includes("'") ? values.customer.replace(/'/g, "''") : values.customer;
  dispatch({ type: GET_CC_ORDER_PROCESSING_REQUEST });
  const newData = {

    to_date: moment(values.to_date).format("YYYY-MM-DD"),
    order_header_no: values.order_no === undefined || values.order_no === "" ? null : values.order_no,
    reference_no: values.po_no === undefined || values.po_no === "" ? null : values.po_no,
    customer: cleanedVal === undefined || cleanedVal === "" ? null : cleanedVal,
    sp_id: values.sale_person === "All" ? null : values.sale_person,
    region_id: values.region === "All" ? null : values.region,
    gender_id: values.gender === "All" ? null : values.gender,
    payment_term_id: values.terms === "All" ? null : values.terms,
    source_type: values.source === undefined || values.source === "" ? null : values.source,
  };

  return axios({
    method: "POST",
    url: `${BASEURL}getAll/ccOrderProcessingReport`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData,
  })
    .then((response) => {
      return dispatch({
        type: GET_CC_ORDER_PROCESSING_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_CC_ORDER_PROCESSING_ERROR,
        payload: [],
      });
    });
};

export const createCCOrderProcessing = (token, data) => (dispatch) => {

  dispatch({ type: CREATE_CC_ORDER_PROCESSING_REQUEST });


  return axios({
    method: "POST",
    url: `${BASEURL}create/SaleOrderLinesTransferCC`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: data,
  })
    .then((response) => {
      return dispatch({
        type: CREATE_CC_ORDER_PROCESSING_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: CREATE_CC_ORDER_PROCESSING_ERROR,
        payload: [],
      });
    });
};

